var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeWave2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    width: 1921.758,
    height: 711.747,
    viewBox: "0 0 1921.758 711.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1607",
    "data-name": "Groupe 1607",
    transform: "translate(0 -549.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_178",
    "data-name": "Trac\\xE9 178",
    d: "M0,8.381,455.54,305.228,765.228,501.662l311.547,95.959,107.058,41.528h228.835l176.547-41.528,106.738-81.075,159.411-241.919L1920,45.635v666.3H0Z",
    transform: "translate(0 549)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_177",
    "data-name": "Trac\\xE9 177",
    d: "M0,552.195S519.241,915.072,614.555,968.572s413.762,250.525,715.927,236.9,449.63-219.736,492.731-291.406,98.545-206.177,98.545-206.177V543.927S1846.247,784.356,1798.3,857.774c-24.548,37.59-92.455,159.884-194.423,214.158-54.514,34.655-159.98,55.8-263.176,57.137-79.755,1.034-160.6-13.352-200.594-19.724-84.568-13.473-172.3-45.384-198.726-53.066-83.066-24.145-164.575-63.9-223.629-87.708-48.791-19.674-240.482-137.8-369.143-227.515C270.826,686.817,71.166,567.214,53.265,555.446,17.145,531.7,0,515.8,0,515.8Z",
    transform: "translate(0 33.389)",
    fill: "#532c6e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWave2);
export default __webpack_public_path__ + "static/media/home-wave2.5ba21c99bbc02085280c68a4e3f84142.svg";
export { ForwardRef as ReactComponent };